<template>
	<div>
		<!-- note below div contains audio style -->
		<div class="secsub-left-quescontainer">
			<div class="sec-quescard d-flex flex-column">
				<div
					class="sec-quescardonopen-header d-flex mb-1 align-items-center justify-content-between pointer"
					v-if="showansweroptions"
					@click="showansweroptions = !showansweroptions"
				>
					<div class="sec-quescard-headtext">Descriptive</div>
					<div class="d-flex pointer">
						<div
							v-if="roles.includes('PUT_AUTO_QUESTION')"
							@click.stop="(editModal = !editModal), copyingVal()"
							class="mr-3"
						>
							<img
								v-b-popover.hover.top="'Edit'"
								src="../../assets/editicon.svg"
								alt=""
							/>
						</div>
						<div
							v-if="roles.includes('DELETE_AUTO_QUESTION')"
							@click.stop="deleteModal = !deleteModal"
							class="mr-3"
						>
							<img
								v-b-popover.hover.top="'Delete'"
								src="../../assets/deleteicon.svg"
								alt=""
							/>
						</div>
						<div>
							<img src="../../assets/uparrow.svg" alt="" />
						</div>
					</div>
				</div>
				<div class="d-flex relativeclass">
					<div class="sec-colorbarColor mt-1" style="background: #d292f0"></div>
					<div
						class="ml-3 align-items-center"
						style="width: 95%; padding: 10px 0"
						@click="showansweroptions = true"
					>
						<div class="sec-quescard-headtext" v-if="!showansweroptions">
							Descriptive
						</div>

						<div class="sec-ques-style relativeclass">
							<template v-if="!showansweroptions">
								<div class="d-flex">
									<div>Q{{ showindex }}.</div>
									<div
										class="topicDescBreak ml-1"
										v-html-safe="$options.filters.MMQfilter(data.question)"
									></div>
								</div>
							</template>
							<template v-else>
								<!-- question desplay -->
								<div class="relativeclass">
									<div class="d-flex">
										<div>Q{{ showindex }}.</div>
										<div
											class="ml-1 topicDescBreak"
											v-html-safe="data.question"
										></div>
									</div>
									<!-- image display logic -->
									<template v-if="'questionMedia' in data">
										<div
											v-if="isImage(data.questionMediaType)"
											class="mt-2 d-flex align-items-center justify-content-center"
										>
											<div class="relativeclass">
												<img
													:src="data.questionMedia"
													alt=""
													class="dbmcqcardimage"
												/>
											</div>
										</div>

										<!-- below div comes if audio exists -->
										<div v-if="isAudio(data.questionMediaType)">
											<div
												class="d-flex mt-2 align-items-center justify-content-center"
											>
												<div>
													<Media
														:kind="'audio'"
														:isMuted="false"
														:autoplay="false"
														:controls="true"
														:loop="true"
														class="mcqdatacard-audio"
														:src="data.questionMedia"
													></Media>
												</div>
											</div>
										</div>

										<div
											v-if="isVideo(data.questionMediaType)"
											class="d-flex mt-2 align-items-center justify-content-center"
										>
											<div class="relativeclass">
												<Media
													:kind="'video'"
													:isMuted="false"
													:src="data.questionMedia"
													:autoplay="false"
													:controls="true"
													:loop="true"
													class="dbmcqcardimage"
												></Media>
											</div>
										</div>
									</template>
								</div>
								<div v-if="data.correctAnswer">
									<b-row>
										<b-col>
											<div class="topDiv mt-3 relativeclass">
												<label class="addquesboxfieldsetStyle">
													Answer &nbsp;</label
												>
												<b-form-textarea
													class="sec-ques-style answer-scroll"
													disabled
													style="width: 80%"
													v-model="data.correctAnswer"
													rows="3"
													max-rows="6"
												>
												</b-form-textarea>
											</div>
										</b-col>
									</b-row>
								</div>

								<div
									class="d-flex"
									style="width: 100%"
									v-if="data.questionTags.length > 0"
								>
									<div
										style="width: 90%"
										:class="questagmore ? 'questag-elipsis' : ''"
									>
										<div class="d-flex flex-wrap ml-3">
											<div
												class="view-questags pl-2 pr-2 pt-1 pb-1 mr-2 mt-2"
												v-for="qt in data.questionTags"
												:key="qt"
												v-b-popover.hover.top="qt"
											>
												{{ qt | fnName }}
											</div>
										</div>
									</div>
									<b-input-group-append
										v-if="data.questionTags.length > 6 && questagmore"
										@click="changequestagmore()"
										style="width: 10%"
										class="text-center mt-1"
									>
										<div type="button" class="questag-more-btn">
											view more
											<img src="../../assets/whitecarrotdown.svg" alt="" />
										</div>
									</b-input-group-append>
									<b-input-group-append
										class="text-center mt-1"
										v-if="data.questionTags.length > 6 && questagmore == false"
										@click="changequestagmore()"
										tyle="width:10%"
									>
										<div type="button" class="questag-more-btn">
											view less
											<img src="../../assets/whiteuparrow.svg" alt="" />
										</div>
									</b-input-group-append>
								</div>
								<template v-if="data.questionTags.length > 0">
									<hr class="ml-3" />
								</template>
								<div class="d-flex align-items-center mt-2">
									<div
										class="card-req-show"
										v-if="data.questionConfig.required"
									>
										<img
											src="../../assets/rightmark.svg"
											alt=""
											class="mr-2"
										/>Required
									</div>
								</div>
							</template>
						</div>

						<div class="sec-icons-style d-flex align-items-center">
							<template v-if="'questionMedia' in data && !showansweroptions">
								<div
									v-if="isImage(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/image.svg" alt="" />
									<span class="ml-2">Image</span>
								</div>
								<div
									v-if="isAudio(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/audio.svg" alt="" />
									<span class="ml-2">Audio</span>
								</div>
								<div
									v-if="isVideo(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/vedio.svg" alt="" />
									<span class="ml-2">Video</span>
								</div>
							</template>
						</div>
					</div>
					<div
						class="d-flex align-items-center pointer mcqcard-downarrow"
						style="width: 3%"
						@click="(showansweroptions = !showansweroptions), copyingVal()"
					>
						<img
							src="../../assets/downarrow.svg"
							alt=""
							v-if="!showansweroptions"
						/>
					</div>
					<div
						class="display-card-mark-tag d-flex align-items-center mt-2"
						style="background: #d292f0"
					>
						<div class="display-card-mark-text">Marks</div>
						<div class="display-card-mark-number ml-2">{{ data.marks }}</div>
					</div>
				</div>
			</div>
		</div>

		<!-----------------  Delete Popup starts -------->
		<b-modal
			id="deleteTopicModal"
			v-model="deleteModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="closedeletemodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to delete the selected question?</span>
			</div>
			<div class="caution-modal-text">Delete from</div>
			<div>
				<b-form-group v-slot="{ ariaDescribedby }">
					<b-form-radio
						class="caution-modal-text"
						v-model="selected"
						:aria-describedby="ariaDescribedby"
						name="some-radios"
						value="A"
						>Test only</b-form-radio
					>
					<b-form-radio
						class="caution-modal-text"
						v-model="selected"
						:aria-describedby="ariaDescribedby"
						name="some-radios"
						value="B"
						>Test and Questionbank</b-form-radio
					>
				</b-form-group>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>

			<div
				@click="deleteLong()"
				class="d-flex align-items-center justify-content-end mt-3"
			>
				<b-button class="addbtn">Delete</b-button>
			</div>
		</b-modal>

		<!-----------------  Delete Popup ends -------->

		<!-- Edit MCQ question Modal Starts -->
		<b-modal
			id="modal-mcq-add"
			v-model="editModal"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
			size="xl"
			no-close-on-backdrop
		>
			<div class="modalheading">Edit Descriptive</div>
			<div @click="closeEditmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div :class="{ 'form-disabled': isUploadLocked }">
				<div class="qb-match-options-overflow">
					<b-row>
						<b-col>
							<div class="topDiv mt-3 relativeclass questypedisable">
								<label class="fieldsetStyle"
									>Question Type &nbsp;<span class="asterik">*</span></label
								>
								<b-form-input
									type="text"
									v-model="questionType"
									class="edit-disabledinputfield"
									disabled
								></b-form-input>
							</div>
						</b-col>
						<b-col>
							<div class="topDiv mt-3 relativeclass">
								<label class="fieldsetStyle"
									>Marks Alloted&nbsp;<span class="asterik">*</span></label
								>
								<b-form-input
									class="edit-inputfield pr-35"
									v-model="$v.clone.marks.$model"
									placeholder="Marks"
									:class="{
										error: $v.clone.marks.$error,
									}"
									@keypress="validateMarks($event)"
								></b-form-input>
								<div
									style="position: absolute; top: 5px; right: 12px"
									v-if="$v.clone.marks.$dirty && !$v.clone.marks.required"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 5px; right: 12px"
									v-if="!$v.clone.marks.alpha && $v.clone.marks.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Accepts only 2 digit after decimal point',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 5px; right: 12px"
									v-if="!$v.clone.marks.between && $v.clone.marks.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Should be between (0.5, 100)',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</b-col>
					</b-row>
					<b-row class="questiontagcontainer">
						<b-col cols="6">
							<div class="topDiv mt-4 qb-other-textDIff">
								<label class="fieldsetStyle"
									>Difficulty level<span class="asterik">*</span></label
								>
								<div
									class="editquesdropdown d-flex justify-content-between pointer"
									@click="qbdropdiff = !qbdropdiff"
								>
									<span>Difficulty Level {{ clone.difficultyLevel }}</span>
									<span>
										<img
											v-if="!qbdropdiff"
											src="../../assets/assess-main-downArrow.svg"
											alt=""
											class="mr-1"
										/>
										<img
											v-else
											class="mr-1"
											src="../../assets/assess-main-upArrow.svg"
											alt=""
										/>
									</span>
								</div>
								<div v-if="qbdropdiff" class="qb-dropdown-option-add d-flex">
									<b-form-group
										class="qb-dd-group-diff"
										v-slot="{ ariaDescribedby }"
									>
										<b-form-radio-group
											@change="qbdropdiff = !qbdropdiff"
											class="qb-add-drop width-full"
											id="btn-radios-4"
											v-model="$v.clone.difficultyLevel.$model"
											:options="options"
											:aria-describedby="ariaDescribedby"
											name="radio-btn-stacked"
											buttons
											stacked
											:class="{
												error: $v.clone.difficultyLevel.$error,
											}"
										></b-form-radio-group>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												$v.clone.difficultyLevel.$dirty &&
													!$v.clone.difficultyLevel.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</b-form-group>
								</div>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="topDiv mt-4 ckeditor">
								<label class="addquesboxfieldsetStyle"> Question Tags</label>
								<b-form-tags
									v-model="clone.questionTags"
									no-outer-focus
									separator=" "
									remove-on-delete
								>
									<template
										v-slot="{
											tags,
											inputAttrs,
											inputHandlers,
											tagVariant,
											removeTag,
											addTag,
										}"
									>
										<b-input-group
											class="mb-2 cust-group-input"
											id="addcontainer-tag-edit"
										>
											<div
												class="qb-transparent d-flex cust-group-input"
												style="width: 90%"
											>
												<div
													class="d-inline-block cust-btn-select mt-2"
													style="font-size: 1.5rem"
												>
													<b-form-tag
														v-for="tag in tags"
														@remove="removeTag(tag)"
														:key="tag"
														:title="tag"
														:variant="tagVariant"
														class="ml-1"
														>{{ tag }}</b-form-tag
													>
												</div>
												<b-form-input
													id="input-tag-edit"
													v-bind="inputAttrs"
													v-on="inputHandlers"
													@keyup="hashtag()"
													placeholder="Enter Question tag"
													style="border-bottom: unset"
													class="form-control min-width mr-4 ml-2"
												></b-form-input>
											</div>

											<b-input-group-append>
												<b-button
													@click="addTag()"
													variant="outline"
													class="cursor-pointer"
												>
													<img src="../../assets/addicongraywhite.svg" alt="" />
												</b-button>
											</b-input-group-append>
										</b-input-group>
									</template>
								</b-form-tags>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12">
							<div class="topDiv mt-3 relativeclass">
								<div
									:class="
										dirtyLongQuestion ||
										(!$v.clone.question.maxLength && !dirtyLongQuestion)
											? 'error'
											: ''
									"
								>
									<label class="addquesboxfieldsetStyle" style="z-index: 5">
										Question &nbsp;<span class="asterik">*</span></label
									>
									<QuillEditor
										:addquesProp="addques"
										:value="$v.clone.question.$model"
										@validationVal="validateText"
										@questionText="updateQuestionContent"
										@addquesBack="changedaddQues"
									></QuillEditor>

									<div
										style="position: absolute; top: 5px; right: 3vw"
										v-if="dirtyLongQuestion && $v.clone.question.required"
										v-b-popover.hover.top.v-danger="{
											content: 'Required',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>

									<div
										style="position: absolute; top: 5px; right: 3vw"
										v-if="!$v.clone.question.maxLength && !dirtyLongQuestion"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not exceed 10000 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
								<div class="media-box mt-2 align-items-center">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="d-flex align-items-center">
											<div class="media-text ml-3">Add Media</div>
											<div class="ml-2">
												<img src="../../assets/vertical-line.svg" alt="" />
											</div>
											<div class="d-flex align-items-center ml-2 mt-1">
												<div
													class="ml-2"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Audio supported formats are: wav, mp3"
												>
													<label for="file-uploadedit" class="pointer">
														<img src="../../assets/headphone.svg" alt="" />
													</label>
													<input
														id="file-uploadedit"
														type="file"
														accept="audio/*"
														@change="previewFile"
													/>
												</div>
												<div
													class="ml-3"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Video supported formats is: mp4"
												>
													<label for="file-upload-videoedit" class="pointer">
														<img src="../../assets/videocam.svg" alt="" />
													</label>
													<input
														id="file-upload-videoedit"
														type="file"
														accept="video/*"
														@change="previewFile"
													/>
												</div>
												<div
													class="ml-3"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Image supported formats are: jpg, jpeg, png"
												>
													<label for="file-upload-imageedit" class="pointer">
														<img src="../../assets/image-capture.svg" alt="" />
													</label>
													<input
														id="file-upload-imageedit"
														type="file"
														accept="image/*"
														@change="previewFile"
													/>
												</div>
											</div>
										</div>
										<div
											class="d-flex align-items-center"
											v-if="clone.isFailed == true"
										>
											<img src="../../assets/Vector.svg" alt="" class="mr-2" />
											<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
										</div>
									</div>
								</div>
								<div
									style="position: absolute; top: 5px; right: 3vw"
									v-if="dirtyLongQuestion && !$v.clone.question.required"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</b-col>
						<b-col cols="12">
							<template
								v-if="
									'questionMedia' in clone &&
										clone.questionMedia !== null &&
										this.checkMedia == true
								"
							>
								<div class="mt-4 mediaPosition">
									<div class="relativeclass">
										<div @click="removeMedia()" class="qb-cancel-image">
											<img src="../../assets/CloseImg.svg" alt="" />
										</div>
										<div
											class="dbmcqcardimage"
											v-if="isImage(clone.questionMediaType)"
										>
											<img
												:src="clone.questionMedia"
												alt=""
												class="w-100 h-100"
											/>
										</div>

										<div v-if="isAudio(clone.questionMediaType)">
											<Media
												:kind="'audio'"
												:isMuted="false"
												:src="clone.questionMedia"
												:autoplay="false"
												:controls="true"
												:loop="true"
												width="70%"
												class="qb-audio-preview"
											></Media>
										</div>
										<div v-if="isVideo(clone.questionMediaType)">
											<Media
												:kind="'video'"
												:isMuted="false"
												:src="clone.questionMedia"
												:autoplay="false"
												:controls="true"
												:loop="true"
												width="70%"
												height="30%"
												class="qb-vedio-preview"
											></Media>
										</div>
									</div>
								</div>
							</template>
						</b-col>
					</b-row>
					<b-row v-if="showVideoUploading">
						<b-col class="ab-uploaded-card w-100 mt-3">
							<b-card no-body class="d-flex w-100">
								<section class="d-flex align-items-center pt-1">
									<div
										class="ab-uploaded-file-heading d-flex align-items-center w-75"
									>
										{{ videoData.name }}
									</div>

									<div
										class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
									>
										<b-spinner v-if="showSpinner" label="Spinning"></b-spinner>
										<span>{{ formatSize(videoData.size) }}</span>
										<!-- <span class="ml-2"> 2 sec Left</span> -->
									</div>
									<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
								</section>
								<section class="mt-2">
									<b-progress height="4px" :value="progress"></b-progress>
								</section>
							</b-card>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<div class="topDiv mt-3 relativeclass">
								<label class="addquesboxfieldsetStyle"> Answer &nbsp;</label>
								<b-form-textarea
									style="overflow-y: auto"
									class="sec-ques-style"
									placeholder="Enter something..."
									rows="3"
									max-rows="6"
									v-model="$v.clone.correctAnswer.$model"
									:class="{
										error: $v.clone.correctAnswer.$error,
									}"
								></b-form-textarea>
								<div
									style="position: absolute; top: 5px; right: 50px"
									v-if="!$v.clone.correctAnswer.maxLength"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 1024 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</b-col>
					</b-row>
				</div>

				<div
					class="sec-addquescheckboxcontainer m-3 d-flex justify-content-between"
				>
					<div class="d-flex align-items-center">
						<b-form-checkbox
							class="ml-3 sec-checboxtext"
							v-model="clone.required"
						>
							Required
						</b-form-checkbox>
					</div>
					<div class="d-flex pointer relativeclass align-items-center">
						<div class="sec-addcheckboxtext mr-3">
							<span @click="UpdateData()">Update</span>
						</div>

						<div v-if="editshowdatacard">
							<div class="edit-datacards d-flex align-items-center">
								<b-form-group class="sec-mcq-datacard">
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="clone.addToDatabank"
										name="flavour-4a"
									>
										Add to Databank
									</b-form-checkbox>
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="clone.addToPublic"
										name="flavour-4a"
									>
										Add to Public
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<!-- Edit MCQ question Ends -->

		<!-- Upload Modal start -->
		<b-modal
			id="attachdocs"
			v-model="attachdocs"
			centered
			hide-footer
			hide-header
			@show="resetModal"
			@hidden="resetModal"
			no-close-on-backdrop
		>
			<div @click="closeattachdocsmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="relativeclass sec-attachdocs">
				<div class="dot-main">
					<div
						class="d-flex align-items-center justify-content-center flex-column"
					>
						<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
							<div>
								<label for="file-upload" class="custom-file-upload pointer">
									<div>
										<img
											src="../../assets/icons/Qpbuilder/uploadicon.svg"
											alt=""
										/>
									</div>
									Click to browse or drag <br />and drop your files
								</label>
								<input id="file-upload" type="file" @change="previewFile" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<!-- Upload Modal end -->
		<b-modal
			id="confirm-edit-modal"
			v-model="editConfirm"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			class="qb-add-ques-modal"
		>
			<b-overlay
				id="overlay-background"
				:show="LoaderStatus"
				variant="white"
				:opacity="overlayOpacity"
				:blur="overlayBlur"
				rounded="sm"
			>
				<div
					class="modalheading d-flex align-items-center justify-content-between"
				>
					Caution !
					<img class="pr-3" src="../../assets/caution.svg" alt="" />
				</div>
				<div @click="closelongEditmModal()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<div v-if="!createnew">
					<div class="mt-3 caution-modal-text">
						<span>Are you sure you want to update ?</span>
					</div>
					<div class="mt-2 caution-modal-text">
						This question is tagged to more than one test. Do you want to create
						a new question or confirm the action?
					</div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button class="addbtn mr-2" @click="createNew()"
							>Create New</b-button
						>
						<div class="sec-canceltext pointer" @click="confirm()">Confirm</div>
					</div>
				</div>
				<div class="caution-modal-text" v-else>
					<div class="modalheading mb-2">
						<img
							src="../../assets/icons/Reports/bckarrow.svg"
							alt=""
							class="mb-1 pointer"
							@click="createnew = false"
						/>
						Create New
					</div>
					Are you sure you want to create new question ?
					<div class="mt-2">
						<span class="asterik">*</span
						><span>Please note this action cannot be undone</span>
					</div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button class="addbtn mr-2" @click="createwith()"
							>Create New With Existing</b-button
						>
						<div class="sec-canceltext pointer" @click="createwithout()">
							Create New & Delete Existing
						</div>
					</div>
				</div>
			</b-overlay>
		</b-modal>
	</div>
</template>
<script>
import QuillEditor from "../forms/quillEditor.vue"; //Quill editor from component

import Media from "@dongido/vue-viaudio";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";

import toast from "../../views/mixin/toast";
import { mapGetters } from "vuex";
import {
	putCommonQuestionv2,
	postCommonQuestionv2,
} from "../../utils/apiFunctions";
import socketUploadMixin from "@/views/mixin/socketUploadMixin";

import {
	required,
	maxLength,
	helpers,
	between,
} from "vuelidate/lib/validators";

export default {
	name: "LongAnswerCard",
	mixins: [toast, socketUploadMixin],
	data() {
		return {
			showVideoUploading: false, // controls ab-uploaded-card visibility
			progress: 0, // progress bar value
			videoData: {}, // { name, size }
			showSpinner: false, // spinner near size
			addques: false,
			LoaderStatus: false,
			overlayOpacity: 0.46,
			overlayBlur: "4",
			dirtyLongQuestion: false,
			questionType: "Descriptive",
			selected: "A",
			file: "",
			modalShow: true,
			correctAnswer: "",
			showdatacard: false,
			editshowdatacard: false,
			showansweroptions: false,
			checkMedia: false,
			attachdocs: false,
			editModal: false,
			deleteModal: false,
			questagmore: true,
			check: true,
			editConfirm: false,
			createnew: false,
			autoCorrection: false,
			required: false,
			addToPublic: false,
			addToDatabank: false,
			qbdropdiff: false,
			clone: {},

			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-","insertTable"],
			},
			adddatatype_selected: [],
			adddataoptions: [
				{
					value: true,
					text: "Add to Data Bank",
				},
				{
					value: true,
					text: "Add to Public",
				},
			],
			options: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],
		};
	},
	validations: {
		clone: {
			marks: {
				required,
				alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/),
				between: between(0.5, 100),
			},
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			correctAnswer: {
				maxLength: maxLength(1024),
			},
		},
	},
	components: {
		Media,
		QuillEditor,
	},
	props: {
		data: Object,
		showindex: Number,
		autosectionID: String,
	},
	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		...mapGetters("autotestVUEX", {
			selectedSection: "getSelectedSection",
			topicID: "getAutoTopicID",
		}),
		...mapGetters("sectionVUEX", {
			questionAdded: "getQuestionAdded",
		}),
		...mapGetters(["roles"]),
		cssForDynamicColor() {
			return {
				"--dynamicBorderColor":
					"#" +
					Math.random()
						.toString(16)
						.slice(2, 8),
			};
		},
	},
	mounted() {
		this.$forceUpdate();
	},
	created() {
		this.copyingVal();
	},
	methods: {
		validateMarks(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		changequestagmore() {
			this.questagmore = !this.questagmore;
			this.$forceUpdate();
		},
		removeMedia() {
			this.clone.questionMedia = "";
			this.clone.questionMediaType = "";
			this.checkMedia = false;
			this.file = "";
			this.clone.fileMeta = null;
			this.$forceUpdate();
		},
		validateText(val) {
			this.dirtyLongQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.clone.question = newContent;
		},
		changedaddQues(newval) {
			this.addques = newval;
		},
		getDesiredContent() {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = this.clone.question;
			const pTags = tempDiv.querySelectorAll("p");

			let endIndex = pTags.length;

			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}
			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});
			this.clone.question = tempDiv.innerHTML;
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		closelongEditmModal() {
			if (!this.LoaderStatus) {
				this.$bvModal.hide("confirm-edit-modal");
			}
		},
		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		isImage,
		isAudio,
		isVideo,
		previewFile: function(event) {
			let mediaType = event.target.id;
			let input = event.target;
			if (input?.files?.[0]) {
				let reader = new FileReader();
				// FOR storing the FILE OBJECT value of a uploaded FILE

				reader.onload = (e) => {
					// FOR storing the binary value of a FILE
					this.clone.questionMedia = e.target.result;
					this.$forceUpdate();
				};
				reader.readAsDataURL(input.files[0]);

				// FOR getting the extension of a particular file
				let parts = input.files[0].name.split(".");
				let ext = parts[parts.length - 1];
				this.clone.questionMediaType = ext;

				// FOR Checking if the fileType is valid or NOT
				if (
					(mediaType == "file-upload-imageedit" &&
						isImage(this.clone.questionMediaType)) ||
					(mediaType == "file-uploadedit" &&
						isAudio(this.clone.questionMediaType)) ||
					(mediaType == "file-upload-videoedit" &&
						isVideo(this.clone.questionMediaType))
				) {
					this.file = input.files[0];
					this.videoData = {
						name: this.file.name,
						size: this.file.size,
					};
					this.clone.fileMeta = {
						content: this.clone.questionMediaType,
					};
					this.clone.isFailed = false;
					this.$bvModal.hide("attachdocs");
					this.checkMedia = true;
				} else {
					// FOR storing the FILE OBJECT Copy of the uploaded FILE
					this.clone.isFailed = true;
					this.checkMedia = false;
					this.file = "";
					delete this.clone.questionMedia;
					delete this.clone.questionMediaType;
				}
			}
			event.target.value = "";
		},
		resetModal() {
			this.moreOption = false;
			this.clone.isFailed = false;
		},
		hashtag() {
			let str = document.getElementById("input-tag-edit").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("input-tag-edit").value = tagged;
		},
		copyingVal() {
			this.data.questionTags = this.data.questionTags.map((s) =>
				s[0] != "#"
					? s.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1")
					: s
			);
			this.moreOption = false;

			this.clone = JSON.parse(JSON.stringify(this.data));

			for (let j in this.data.config) {
				if (
					this.data.config[j].testID == this.$route.params.testID &&
					this.data.config[j].SectionID == this.autosectionID
				) {
					this.clone.required = this.data.config[j].config.required;
					this.clone.autoCorrection = this.data.config[j].config.autoCorrection;
				}
			}
			if ("questionMedia" in this.clone) {
				this.checkMedia = true;
			} else {
				this.checkMedia = false;
			}
		},
		confirm() {
			this.LoaderStatus = true;
			this.addques = true;
			this.check = false;
			this.UpdateData();
		},
		createNew() {
			this.createnew = true;
		},
		async createwithout() {
			await this.createwith();
			this.check = false;
			await this.deleteFromTest();
			this.check = true;
		},

		async createwith() {
			try {
				console.log("createWith");
				this.validateForm();

				delete this.clone.questionKey;
				delete this.clone.licenseKey;
				delete this.clone.type;
				this.clone.questionType = "LONG";

				if (!this.$v.$invalid) {
					const form = this.createFormData();

					const response = await postCommonQuestionv2(form);

					if (response.status == 200) {
						this.handleSuccessResponse(response);
					} else {
						this.errorToast("Something went wrong!");
					}
				}
			} catch (error) {
				this.errorToast("Something went wrong!");
			}
		},
		validateForm() {
			this.$v.$touch();
		},

		createFormData() {
			const form = new FormData();

			for (const key in this.clone) {
				if (key === "questionMedia") {
					this.handleQuestionMedia(form);
				} else if (key === "questionTags") {
					this.handleQuestionTags(form, key);
				} else {
					form.append(key, this.clone[key]);
				}
			}

			form.append("type", "ADD_QUES");
			form.append("selected", "A");
			form.append("delete", "1");

			return form;
		},

		handleQuestionMedia(form) {
			if (this.file === "" && this.clone.questionMedia === "") {
				delete this.clone.questionMedia;
				delete this.clone.questionMediaType;
				form.set("delete", 1);
			} else if (this.file === "" && this.clone.questionMedia !== "") {
				return;
			} else {
				form.append("questionMedia", this.file);
			}
		},

		handleQuestionTags(form, key) {
			this.clone[key] = JSON.stringify(this.clone.questionTags);
			form.append(key, this.clone[key]);
			this.clone[key] = JSON.parse(this.clone[key]);
		},

		handleSuccessResponse(response) {
			this.LoaderStatus = false;
			this.$emit("auto-question-added");
			this.clone.questionKey = response.data.data.QuestionID;
			this.successToast("Question added successfully!");
			this.check = true;
			this.editConfirm = false;
			this.createnew = false;
			this.$store.commit("autotestVUEX/saveAddedQuestion", this.clone);
			this.closeEditmodal();
		},

		async UpdateData() {
			try {
				this.showSpinner = true;
				const form = new FormData();
				this.$v.$touch();

				if (this.validateAndUpdateForm()) {
					let bucketPath = null;

					if (this.file && this.clone.fileMeta) {
						this.showVideoUploading = true;
						bucketPath = await this.uploadFileViaSocket(
							this.file,
							this.clone.fileMeta
						);
					}
					this.setupAndUpdateFormData(form, bucketPath);
					const payload = await this.clone;
					const response = await putCommonQuestionv2(form);

					if (response.status === 200) {
						this.handleUpdateSuccess(response, payload);
						this.showVideoUploading = false;
						this.showSpinner = false;
						this.progress = 0;
						this.videoData = {};
					} else if (response.status === 409) {
						this.handleUpdateConflict();
					} else {
						this.handleUpdateError();
					}
				}
			} catch (error) {
				if (error.response.status === 409) {
					this.handleUpdateConflict();
				} else {
					this.handleUpdateError();
				}
			}
		},

		validateAndUpdateForm() {
			this.clone.sectionID = this.autosectionID;
			this.clone.testID = this.$route.params.testID;
			this.clone.type = "CHANGE_QUES";
			this.clone.topicID = this.topicID;
			this.clone.questionType = "LONG";

			if (this.$v.$invalid || this.dirtyLongQuestion) {
				this.errorToast("Please fill all the mandatory fields");
				return false;
			}

			return true;
		},

		setupAndUpdateFormData(form, bucketPath) {
			let questionTagsForBackend = this.clone.questionTags.map((tag) =>
				tag.startsWith("#") ? tag.substring(1) : tag
			);

			this.getDesiredContent();

			for (const key in this.clone) {
				this.handleUpdateFormData(
					form,
					key,
					questionTagsForBackend,
					bucketPath
				);
			}

			form.append("check", this.check);
		},

		handleUpdateFormData(form, key, questionTagsForBackend, bucketPath) {
			if (key === "questionMedia") {
				this.handleUpdateQuestionMedia(form, bucketPath);
			} else if (key === "questionTags") {
				form.append(key, JSON.stringify(questionTagsForBackend));
			} else {
				form.append(key, this.clone[key]);
			}
		},

		handleUpdateQuestionMedia(form, bucketPath) {
			if (!this.file && !this.clone.questionMedia) {
				form.set("delete", 1);
				return;
			}

			// unchanged media
			if (!this.file && this.clone.questionMedia) {
				return;
			}

			// new / replaced media
			if (bucketPath) {
				form.append("questionMediaPath", bucketPath);
				form.append("questionMediaType", this.clone.questionMediaType);
			}
		},

		handleUpdateSuccess(response, payload) {
			this.LoaderStatus = false;
			this.$emit("auto-question-added");
			this.$store.commit("autotestVUEX/saveEditedQuestion", payload);
			this.check = true;
			this.editConfirm = false;
			this.createnew = false;
			this.showansweroptions = false;
			this.successToast("Question updated successfully!");
			this.$emit("auto-question-added");
			this.addques = false;
			this.closeEditmodal();
		},

		handleUpdateConflict() {
			this.editConfirm = true;
		},

		handleUpdateError() {
			this.errorToast("Something went wrong!");
		},

		// Delete function
		deleteLong() {
			if (this.selected == "A") {
				this.deleteFromTest();
			} else {
				this.deleteFromTestAndDataBank();
			}
		},
		// delete From Test Only
		deleteFromTest() {
			let payload = {
				testID: this.$route.params.testID,
				sectionID: this.autosectionID,
				questionKey: this.data.questionKey,
				type: "DEL_QUES",
				questionType: "LONG",
			};
			this.$store
				.dispatch("autotestVUEX/delAutoQuestions", payload)
				.then((res) => {
					if (res.status == 200) {
						this.successToast("Question deleted successfully!");

						this.$emit("auto-question-added");
						this.$emit("get-auto-sections");
					} else {
						this.errorToast("Something went wrong!");
					}
				})
				.catch((err) => {
					this.errorToast("Something went wrong!");
					throw err;
				});
			//close delete modal
			this.closedeletemodal();
		},
		// delete From Test And DataBank
		deleteFromTestAndDataBank() {
			let payload = {
				testID: this.$route.params.testID,
				sectionID: this.autosectionID,
				questionKey: this.data.questionKey,
				marks: this.data.marks,
				addToDatabank: false,
			};
			this.$store
				.dispatch("questionVUEX/deleteMCQquestion", payload)
				.then((res) => {
					if (res.status == 200) {
						this.successToast("Question deleted successfully!");

						this.$emit("auto-question-added");
						this.$emit("get-auto-sections");
					} else {
						this.errorToast("Something went wrong!");
					}
				})
				.catch((err) => {
					this.errorToast("Something went wrong!");
					throw err;
				});
			//close delete modal
			this.closedeletemodal();
		},
		closeEditmodal() {
			this.dirtyLongQuestion = false;
			this.moreOption = false;
			this.$bvModal.hide("modal-mcq-add");
		},
		closedeletemodal() {
			this.$bvModal.hide("deleteTopicModal");
		},
	},
};
</script>
<style scoped>
.sec-colorbarColor {
	width: 4px;
	border-radius: 2px;
	margin: 3px;
}

.Delete-btn {
	color: #ffffff;
	border: transparent;
	background-color: #c92b2b;
	width: 100px;
	float: right;
}

.Delete-btn:hover {
	color: #ffffff;
	border: transparent;
	background-color: #c92b2b;
	width: 100px;
}

.Delete-btn:focus,
.Delete-btn.focus {
	outline: none;
	box-shadow: 0 0 0 0;
	color: #ffffff;
	border: transparent;
	background-color: #c92b2b;
	width: 100px;
}
.xMarkCancelColor {
	color: gray !important;
}
.card {
	border-radius: 12px;
	margin: 2%;
	box-shadow: 7px 10px 7px #c5c2c2;
	text-align: left;
}

.card-header {
	padding-top: 0.5rem;
	padding-bottom: -1rem;
	background-color: transparent;
}

.display-choice {
	display: flex;
	justify-content: space-between;
}

.display-choice p {
	padding: 7px 0;
	margin: 0;
	font-size: 20px;
	color: #707070;
	font-weight: 500;
}

.social-icon {
	padding: 0;
	margin: 0;
}

.social-icon li {
	list-style: none;
	display: inline-block;
	padding: 0 4px;
	margin-right: -3px;
}

.audio-preview {
	width: 500px;
	height: 245px;
	object-fit: contain;
	background-color: white;
	border: 1px solid #ddd;
	padding: 5px;
	display: flex;
	flex-wrap: wrap;
	align-content: center;
}

.preview {
	width: 500px;
	height: 245px;
	object-fit: contain;
	background-color: white;
	border: 1px solid #ddd;
	padding: 5px;
	display: flex;
	flex-wrap: wrap;
	align-content: center;
}

.rounded-circle {
	border-color: transparent;
	background-color: #f2f2f2;
}

.bcard-text {
	color: #808080;
	font-weight: 400;
}

.switch {
	margin-top: 2vh;
	margin-right: 2vh;
}

.header-btns:hover {
	background-color: #f5f5f5;
	color: #6c757d;
	border-color: #f5f5f5;
}

.header-btns:not(:disabled):not(.disabled):active,
.header-btns:not(:disabled):not(.disabled).active,
.show > .header-btns.dropdown-toggle {
	background-color: #f5f5f5;
	color: #6c757d;
	border-color: #f5f5f5;
	box-shadow: 0 0 0 0 !important;
}

.audio-class {
	width: 30vw;
	height: 4vh;
	margin-bottom: 10px;
}
.answer-scroll {
	overflow-y: auto !important;
}
</style>
